import { CoerceDateSchema, NaturalNumberSchema } from '@mntn/zod'
import { z } from 'zod'

/**
 * Standard audit columns shared by tables with createdBy/updatedBy plus
 * timestamps.
 */
export const AuditColumnsSchema = z.object({
  createTime: CoerceDateSchema,
  updateTime: CoerceDateSchema,
  createdBy: NaturalNumberSchema,
  updatedBy: NaturalNumberSchema,
})
export type AuditColumns = z.infer<typeof AuditColumnsSchema>
